import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { EshavaControlOptionItem } from 'eshava-controls';

@Component({
    selector: 'lib-eshava-radio-buttons',
    templateUrl: './eshava-radio-buttons.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './eshava-radio-buttons.component.scss'
})
export class EshavaRadioButtonsComponent {

  @Input()
  public items: EshavaControlOptionItem[] = [];

  @Input()
  public name: string = '';

  @Input()
  public disabled: boolean = false;

  @Output()
  public selected: EventEmitter<any> = new EventEmitter<any>();

  public onSelect(item: EshavaControlOptionItem): void {
    for (const element of this.items.filter(i => i.value !== item.value)) {
      element.isSelected = false;
    }

    item.isSelected = true;
    this.selected.next(item.value);
  }
}
